import { useState, useEffect, useCallback } from 'react';
import { useDispatch } from "react-redux";
import * as d3 from 'd3-scale-chromatic';

const useColorPicker = (id, initialColor, updateColorAction) => {
    const dispatch = useDispatch();
    const [color, setColor] = useState(initialColor || d3.interpolateRainbow(Math.random()));

    useEffect(() => {
        if (!initialColor) {
            const randomColor = d3.interpolateRainbow(Math.random());
            setColor(randomColor);
            dispatch(updateColorAction({ id: id, color: randomColor }));
        }
    }, [dispatch, updateColorAction, id, initialColor]);

    const handleColorUpdate = useCallback((newColor) => {
        console.log('Updating color', newColor);
        setColor(newColor.hex);
        dispatch(updateColorAction({ id: id, color: newColor.hex }));
    }, [dispatch, updateColorAction, id]);

    return [color, handleColorUpdate];
};

export default useColorPicker;
